'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _iso = require('iso-639-1');

var _iso2 = _interopRequireDefault(_iso);

var _data = require('./data.js');

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ISO6391ZH = function (_ISO) {
  (0, _inherits3.default)(ISO6391ZH, _ISO);

  function ISO6391ZH() {
    (0, _classCallCheck3.default)(this, ISO6391ZH);
    return (0, _possibleConstructorReturn3.default)(this, (ISO6391ZH.__proto__ || (0, _getPrototypeOf2.default)(ISO6391ZH)).apply(this, arguments));
  }

  (0, _createClass3.default)(ISO6391ZH, null, [{
    key: 'getLanguages',
    value: function getLanguages(codes) {
      return (0, _get3.default)(ISO6391ZH.__proto__ || (0, _getPrototypeOf2.default)(ISO6391ZH), 'getLanguages', this).call(this, codes).map(function (language) {
        (0, _assign2.default)(language, {
          zhName: ISO6391ZH.getZhName(language.code)
        });
        return language;
      });
    }
  }, {
    key: 'getZhName',
    value: function getZhName(code) {
      return (0, _get3.default)(ISO6391ZH.__proto__ || (0, _getPrototypeOf2.default)(ISO6391ZH), 'validate', this).call(this, code) ? _data2.default[code] : '';
    }
  }, {
    key: 'getAllZhNames',
    value: function getAllZhNames() {
      return (0, _values2.default)(_data2.default);
    }
  }]);
  return ISO6391ZH;
}(_iso2.default);

exports.default = ISO6391ZH;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = ./src/index.js
// module chunks = 0